import { useMemo, useState } from "react"

import { MESSAGE_MODALS } from "../../../context/custom/MessageModalContext"
import { OPERATION_MODE } from '@laramie/ui';
import { GetTipoDatos } from "../../../utils/helpers"
import {TIPS} from "../../../consts/tips";

import { Accordion, FormError, FormLabel, MessageModal, Modal, Select, TableCustom } from "../../../components/common"
import { useFormErrors, useManagedContext } from "../../../components/hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"

const Parametros = ({ params, data, setData, setPendingChange }) => {
    const { showMessageModal } = useManagedContext();

    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()

    const filteredData = useMemo(() => data.filter(x => x.state !== 'r'), [data])

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}
        if (!editItem) return errors

        if (editItem.codigo.length < 1) errors.codigo = VALIDATION_MESSAGE.REQUIRED_SHORT
        if (editItem.nombre.length < 1) errors.nombre = VALIDATION_MESSAGE.REQUIRED
        if (!editItem.orden) errors.orden = VALIDATION_MESSAGE.REQUIRED_SHORT

        return errors
    }

    //#region events
    const onAdd = (item) => {
        setEditItem({
            id: -Date.now(),
            idProcedimiento: parseInt(params.id),
            codigo: '',
            nombre: '',
            tipoDato: '',
            orden: 0,
            state: 'a',
        })
        setEditMode('add')
    }

    const onView = (item) => {
        setEditItem(item)
        setEditMode('view')
    }

    const onModify = (item) => {
        setEditItem({ ...item, state: item.state === 'a' ? 'a' : 'm' })
        setEditMode('modify')
    }

    const onModalExit = () => {
        setEditItem(null)
        setEditMode(null)
        reset()
    }

    const onModalConfirm = () => {
        if (!validate()) return

        if (editMode === 'modify') {
            setData(data.map(x => x.id === editItem.id ? editItem : x))
        }
        if (editMode === 'add') {
            setData([...data, editItem])
        }

        setPendingChange(true)
        onModalExit()
    }

    const onClickRemove = (item) => {
        showMessageModal({
            ...MESSAGE_MODALS.BORRAR,
            message: `¿Está seguro de borrar el parámetro ${item.nombre}?`,
            onConfirm: () => {
                if (item.state === 'a') setData(data.filter(x => x.id !== item.id))
                else setData(data.map(x => x.id !== item.id ? x : {...x, state: 'r'}))
                setPendingChange(true)
            }
        })
    }
    //#endregion

    const cellAVMR = {
        id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true,
        Header: (props) => (
            <div className='action'>
                {params.mode !== OPERATION_MODE.VIEW && (
                    <div onClick={onAdd} className="link">
                        <span className="material-symbols-outlined" title="Nuevo">add</span>
                    </div>
                )}
            </div>
        ),
        Cell: (props) =>  (
            <div className='action'>
                <div onClick={() => onView(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Ver">search</span>
                </div>
                {params.mode !== OPERATION_MODE.VIEW && <>
                    <div onClick={() => onModify(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Modificar">stylus</span>
                    </div>
                    <div onClick={() => onClickRemove(props.row.original)} className="link">
                    <span className="material-symbols-outlined" title="Eliminar">delete</span>
                    </div>
                </>}
            </div>
        ),
    }

    return <>
        <Accordion title="Parámetros" className="m-top-20">
            <div className='row form-basic'>
                <TableCustom
                    className={'TableCustomBase'}
                    data={filteredData}
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '45%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '45%', },
                        cellAVMR,
                    ]}
                />
            </div>
        </Accordion>

        {editItem && (
            <Modal
                onEscape={onModalExit}
                show={!!editItem}
                title='Parámetro'
                tipName={TIPS.NAME.MODALS.PARAMETRO_MODAL}
                header={<div/>}
                body={(
                    <Accordion title="Datos del parámetro" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-2">
                                <FormLabel htmlFor="nombre" required>Código</FormLabel>
                                <input
                                    name="nombre"
                                    type="text"
                                    placeholder=""
                                    className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                                    value={editItem.codigo}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, codigo: target.value}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError message={errorOf('codigo')} />
                            </div>
                            <div className="col-12 col-md-5">
                                <FormLabel htmlFor="descripcion" required>Nombre</FormLabel>
                                <input
                                    name="descripcion"
                                    type="text"
                                    placeholder=""
                                    className={`form-control ${errorOf('nombre') ? 'is-invalid' : ''}`}
                                    value={editItem.nombre}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, nombre: target.value}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError message={errorOf('nombre')} />
                            </div>
                            <div className="col-12 col-md-3">
                                <label htmlFor="tipoDato" className="form-label">Tipo de dato</label>
                                <Select
                                    name="tipoDato"
                                    className="form-control"
                                    value={editItem.tipoDato}
                                    options={[{ value: '', label: 'Sin selección' }, ...GetTipoDatos().map(item => ({ value: item.key, label: item.value }))]}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, tipoDato: target.value}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError />
                            </div>
                            <div className="col-12 col-md-2">
                                <FormLabel htmlFor="idEstadoProcedimiento" required>Orden</FormLabel>
                                <input
                                    name="orden"
                                    type="number"
                                    placeholder=""
                                    className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                                    value={editItem.orden}
                                    onChange={({ target }) => setEditItem(prev => ({...prev, orden: parseInt(target.value)}))}
                                    disabled={editMode === 'view'}
                                />
                                <FormError message={errorOf('orden')} />
                            </div>
                        </div>
                    </Accordion>
                )}
                footer={<>
                    {editMode !== 'view' && <>
                        <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onModalExit}>Cancelar</button>
                        <button className="btn btn-primary" data-dismiss="modal"  onClick={onModalConfirm}>Aceptar</button>
                    </>}
                    {editMode == 'view' && 
                    <div className="width-100p f-align">
                        <button className="btn back-button" data-dismiss="modal" onClick={onModalExit}>Volver</button>
                    </div>} 
                </>}
            />
        )}
    </>
}

export default Parametros
